module.exports = __webpack_public_path__ + "img/project13_8.jpg.ccbfe91b.webp";